/**
 * @Author chenguanbin
 * @Date 2020-03-18 15:34:43
 * @Desc 企业管理
 */
import http from './instance'

export default {
  /**
   * @author chenguanbin
   * @date 2020-03-18 15:36:00
   * @desc 获取下拉框数据
   */
  Attributes() {
    return http.post(`/v1/enterpriseService/box/Attributes`)
  },

  /**
   * @author chenguanbin
   * @date 2020-03-18 16:22:51
   * @desc 获取行政区数据
   */
  queryAuthRegions() {
    return http.post(`/v1/region/queryAuthRegions`)
  },

  /**
   * @author chenguanbin
   * @date 2020-03-18 16:22:51
   * @desc 获取行政区数据
   */
  queryProviceReg(projectId) {
    return http.post(`/v1/region/queryProviceReg`, { projectId })
  },

  /**
   * @author chenguanbin
   * @date 2020-03-18 16:17:06
   * @desc 分页查询企业信息列表
   */
  pagedEnterprises(params) {
    return http.post(`/v1/enterpriseService/search/pagedEnterprises`, params)
  },

  /**
   * @author chenguanbin
   * @date 2020-03-18 18:58:56
   * @desc 添加企业信息
   */
  save(params) {
    return http.post(`/v1/enterpriseService/save`, params)
  },

  /**
   * @author chenguanbin
   * @date 2020-03-18 18:58:56
   * @desc 更新企业信息
   */
  update(params) {
    return http.post(`/v1/enterpriseService/update`, params)
  },

  /**
   * @author chenguanbin
   * @date 2020-03-19 10:28:14
   * @desc 获取企业信息
   */
  queryEnterprisesInfo(indexCode) {
    return http.get(`/v1/enterpriseService/enterprise/${indexCode}`)
  },

  /**
   * @author chenguanbin
   * @date 2020-03-19 10:53:21
   * @desc 删除企业信息
   */
  delete(indexCodeList) {
    return http.post(`/v1/enterpriseService/batch/delete`, { indexCodeList })
  },

  /**
   * @author chenguanbin
   * @date 2020-03-19 11:28:27
   * @desc 修改企业启用/禁用状态
   */
  changeStatus(indexCodeList, enable) {
    return http.post(`/v1/enterpriseService/disable/modification`, { indexCodeList, enable })
  },

  /**
   * @author chenguanbin
   * @date 2020-03-19 11:28:27
   * @desc 校验统一社会信用代码唯一性
   */
  uniqueVerification(params) {
    return http.post(`/v1/enterpriseService/unique/verification`, params)
  },
  /**
   * 获取历史导入记录
   * @author zhubincong
   * @since 2020-03-21 13:50:35
   */
  importResult(params) {
    return http.post(`/v1/enterpriseService/all/import/result`, params)
  },
  /**
   * 导出校验结果详情
   * @author zhubincong
   * @since 2020-03-21 13:50:35
   */
  exportValidateDetailt(params) {
    return http.get(`/v1/enterpriseService/export/validate/detail`, params)
  },
  /**
   * 导入校验后的企业信息
   * @author zhubincong
   * @since 2020-03-21 13:50:35
   */
  importEnterprise(params) {
    return http.get(`/v1/enterpriseService/import/enterprise`, { params })
  },
  /**
   * 获得企业信息文件的导入进度
   * @author zhubincong
   * @since 2020-03-21 13:50:35
   */
  importProgress(params) {
    return http.get(`/v1/enterpriseService/import/progress`, { params })
  },
  /**
   * 导入企业信息文件校验,返回UUID，之后根据UUID获得校验进度及结果
   * @author zhubincong
   * @since 2020-03-21 13:50:35
   */
  importValidate(params) {
    return http.post(`/v1/enterpriseService/import/validate`, params)
  },
  /**
   * 获取校验结果详情
   * @author zhubincong
   * @since 2020-03-21 13:50:35
   */
  importValidateDetail(params) {
    return http.post(`/v1/enterpriseService/import/validateDetail`, params)
  },
  /**
   * 获得导入企业信息文件的校验进度
   * @author zhubincong
   * @since 2020-03-21 13:50:35
   */
  importValidateProgress(params) {
    return http.get(`/v1/enterpriseService/import/validateProgress`, { params })
  },
  /**
   * 下载企业信息导入模板
   * @author zhubincong
   * @since 2020-03-21 13:50:35
   */
  importTemplate(params) {
    return http.get(`/v1/enterpriseService/importTemplate`, params)
  },
  /**
   * 获取最近一次导入记录
   * @author zhubincong
   * @since 2020-03-21 13:50:35
   */
  recentImport(params) {
    return http.get(`/v1/enterpriseService/recent/import`, { params })
  },
  /**
   * 获取字段说明
   * @author zhubincong
   * @since 2020-03-21 13:50:35
   */
  importTemplateFields(params) {
    return http.get(`/v1/enterpriseService/importTemplate/fields`, { params })
  },

  /**
   * @author xuchen
   * @date 2020-06-18 14:42:31
   * @desc 获取新增和导入权限
   */
  getAddImportRole() {
    return http.get('/common/judgeOperateUserRegion')
  }
}
